import { useEffect, useState } from 'react'
import { getOpinionCitationLinks } from '@/citator/fetch/get-opinion-citation-links'
import type { OpinionCitationLinksResponse } from '@/citator/schema/opinion-citation-link-schema'

const kEmptyLinks: OpinionCitationLinksResponse = []

export function useOpinionCitationLinks(parentId: string | null | undefined) {
  const [result, setResult] = useState<{ parentId: string; links: OpinionCitationLinksResponse } | null>(null)

  useEffect(() => {
    if (!parentId) return
    const controller = new AbortController()
    async function load(opinionParentId: string) {
      let links: OpinionCitationLinksResponse
      try {
        links = await getOpinionCitationLinks(opinionParentId, controller.signal)
      } catch {
        links = kEmptyLinks
      }
      if (!controller.signal.aborted) setResult({ parentId: opinionParentId, links })
    }
    void load(parentId)
    return () => controller.abort()
  }, [parentId])

  return { links: result && result.parentId === parentId ? result.links : kEmptyLinks }
}
